import { render } from "./AddQuestion.vue?vue&type=template&id=2ebc253e&scoped=true"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=2ebc253e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebc253e"]])

export default __exports__